module.exports = "../../app/cells/components/modals/setup_wizard/current_level.erb";